import React from "react";
import { capitalize } from "../../utils/textFunctions";
const Address = ({ data, summary: isSummary, className, type }) => {
  if (isSummary && data.length === 0) {
    return <div>Address: [Empty]</div>;
  }
  if (isSummary) {
    //Filtering data
    const finalData =
      data &&
      data.filter(
        addr =>
          !(Object.keys(addr).length === 1 && addr.hasOwnProperty("extension"))
      );
    let primaryAddress =
      finalData && finalData.filter(addr => addr.use === "home");
    if (primaryAddress && primaryAddress.length === 0) {
      primaryAddress = [finalData[0]];
    }

    const sourceCode =
      primaryAddress[0] && primaryAddress[0].extension
        ? primaryAddress[0].extension.filter(e => e.url.includes("sourceCode"))
        : "";
    const use = primaryAddress[0] && primaryAddress[0].use;
    return (
      <div>
        {primaryAddress[0] && primaryAddress[0].line ? (
          <div>
            Address: {primaryAddress[0].line.join("\n")}{" "}
            {sourceCode[0] ? "[" + sourceCode[0].valueString + "]" : ""}{" "}
            {use ? "[" + capitalize(use) + "]" : ""}
          </div>
        ) : null}
      </div>
    );
  }

  if (!isSummary && data.length === 0) {
    return (
      <section>
        <h3>Addresses</h3>
        <div>
          <h4>Empty</h4>
        </div>
      </section>
    );
  }

  return (
    <section>
      <h3>
        {type === "birthplaceAddress" ? "Birth Place Address" : "Addresses"}
      </h3>
      <div className={className}>
        <div>
          <h4>Address Line</h4>
        </div>
        <div>
          <h4>City</h4>
        </div>
        <div>
          <h4>State</h4>
        </div>
        <div>
          <h4>Postal Code</h4>
        </div>
        <div>
          <h4>Use</h4>
        </div>
      </div>

      {data.map((address, index) => {
        return (
          <div key={index} className={className}>
            <div>
              {address.line
                ? address.line.map((addressLine, lKey) => {
                    return <div key={lKey}>{addressLine}</div>;
                  })
                : "NA"}
            </div>
            <div>
              <div>{address.city ? address.city : "NA"}</div>
            </div>
            <div>
              <div>{address.state ? address.state : "NA"}</div>
            </div>
            <div>
              <div>{address.postalCode ? address.postalCode : "NA"}</div>
            </div>
            <div>
              <div>{address.use ? address.use : "NA"}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Address;
